module.exports = __webpack_public_path__ + "img/九江二手车市场有限公司.516d3457.png";